<template>
    <div class="main">
        <div class="admin-section">
            <form class="container" @submit="onSubmit">
                <div class="row">
                    <h1 class="section-heading col-12"><label for="editor">Edit "About us"</label></h1>
                    <b-overlay :show="loading" class="col-12">
                        <ckeditor id="editor" 
                            v-model="content" 
                            class="col-12"
                            :config="editorConfig">
                        </ckeditor>
                    </b-overlay>
                </div>
                <div class="buttons-container float-right">
                    <b-button @click="onCancel" class="cancel-button">Cancel changes</b-button>
                    <b-button type="submit" class="submit-button">Save changes</b-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { doc, updateDoc } from "firebase/firestore";
import { auth, db } from "../../firebase";

export default {
    name: "EditAboutUs",
    data() {
        return {
            docRef: null,
            content: '',
            inEditing: false,
            editorConfig: {
                height: '18em',
                toolbar: [{
                    name: "undo redo stack",
                    items: ["Undo", "Redo"]
                },{
                    name: "clipboard",
                    items: ["Cut", "Copy", "Paste", "PasteText"]
                },{
                    name: "basicstyles",
                    items: ["Bold", "Italic", "Stike"]
                },{
                    name: "links",
                    items: ["Link", "Unlink"]
                },{
                    name: "list",
                    items: ["NumberedList", "BulletedList"]
                },{
                    name: "insert",
                    items: ["SpecialChar"]
                },{
                    name: "styles",
                    items: ["Format"]
                }]
            }
        }
    },
    watch: {
        remoteContent(newCont) {
            if (!this.content) {
                this.content = newCont;
            }
        }
    },
    computed: {
        remoteContent() {
            return this.$store.state.about;
        },
        loading() {
            return this.inEditing || !this.remoteContent;
        }
    },
    methods: {
        async onSubmit(e) {
            e.preventDefault();

            if (!this.content || this.content.length === 0) {
                alert("About us text should be present.");

                return;
            }

            if (this.content === this.remoteContent) {
                alert('There are no changes made in the text.');
                return;
            }

            if (!this.docRef) {
                this.docRef = doc(db, "common", "aboutus");
            }

            if (this.docRef) {
                try {
                    this.inEditing = true;

                    await updateDoc(this.docRef, {
                        content: this.content
                    });

                    this.$store.commit('setAbout', this.content);

                    alert("About us text updated.");
                } catch {
                    alert("Update was not successful.");
                } finally {
                    this.inEditing = false;
                }
            } else {
                alert("Could not connect to database.");
            }
        },
        onCancel(e) {
            e.preventDefault();
            e.stopPropagation();

            this.content = this.remoteContent;
        }
    },
    mounted() {
        if (!auth.currentUser) {
            this.$router.push('/admin');
        } else {
            this.content = this.remoteContent;
        }
    }
}
</script>